import { safeDefine } from "../../registration/safe-define.js";
import { ContainerElement } from "../../ui/container/element.js";
//#region src/define/ui/container.ts
safeDefine(ContainerElement);
//#endregion
